<template>
<div>
  <v-row>
    <v-col cols="6">
    <v-row>
    <v-col cols="12" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-4"
      v-model="editedItem.systemId" label="System ID" readonly tabindex="-1" />
    </v-col>
    <v-col cols="12" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      v-model="editedItem.mainPropertyOrParcelId" label="Property ID" readonly tabindex="-1" />
    </v-col>
    <v-col cols="12" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      v-model="editedItem.mainSitusAddress" label="Situs Address" readonly tabindex="-1" />
    </v-col>
    <v-col cols="12" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      v-model="editedItem.mainTaxId" label="Tax ID" readonly tabindex="-1" />
    </v-col>
    <v-col cols="12" class="pt-0 pb-0">
      <v-textarea class="input-text-size pt-0 pb-0 mb-n5" v-model="editedItem.mainLegalDesc"
      outlined rows="3" label="Legal Description" readonly tabindex="-1" />
    </v-col>
    </v-row>
  </v-col>
  <v-col cols="6">
    <v-row>
    <v-col cols="4" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-4"
      v-model="editedItem.mainTotalDue" label="Total Due(Taxes + Penalty + Fees)" readonly tabindex="-1" />
    </v-col>
    <v-col cols="4" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-4"
      @focus="amountToNum('winningBid'), $event.target.select()"
      v-model="editedItem.winningBid" label="Winning Bid" @blur="calculateDynamicPriority(), roundAmount('winningBid')" />
    </v-col>
    <v-col cols="4" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-4"
      :value="editedItem.excessResale"  label="Excess Resale Amount" readonly tabindex="-1" />
    </v-col>
    <v-col cols="4" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      :value="amountFormat(editedItem.mainTwoThirdsAssessed)"
      label="2/3 Assessed(2/3 Assessed value + Fees)" readonly tabindex="-1" />
    </v-col>
    <v-col cols="4" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      v-model="editedItem.regNumber" label="Reg #" @blur="updateRegNumber" />
    </v-col>
    <v-col cols="4" class="pt-0 pb-0">
      <v-text-field class="input-text-size ma-0 pa-0 mt-n2"
      v-model="editedItem.bidderName" label="Reg Name" />
    </v-col>
    <v-col cols="6" class="pt-0 pb-0 d-flex">
      <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0"
      v-model="editedItem.cityOwned" label="City Owned" :disabled="editedItem.countyOwned"
      @change="onCountyOwnedChange" />
      <v-checkbox class="input-text-size radio-and-checekbox-size pa-0 ma-0 ml-5"
      v-model="editedItem.countyOwned" label="County Owned" :disabled="editedItem.cityOwned"
      @change="onCountyOwnedChange" />
    </v-col>
    <v-col cols="6" class="pt-0 pb-0">
      <v-btn class="input-text-size" text color="blue darken-1 pa-0 ma-0"
      @click="createAdjustments" :loading="creatingAdjustments"
      :disabled="disableCreateAdjustments || creatingAdjustments">
      Create Adjustments</v-btn>
    </v-col>
    <v-col cols="12" class="pt-0 pb-0">
      <CRUDList ref="crudList" :canAdd="false" :headers="headers"
      :displayTopPagination="false" :canEdit="false"
      :canSave="false" :showDialog="false"
      :disablePagination="true" :hideDefaultFooter="true"
      :enableFixedHeaders="true" :baseCrudKey="baseCrudKeyPriority"
      :defaultSortBy="defaultSortBy"
      tableWrapperDynamicClassname="pa-1 pb-5 taxroll-table-wrapper"
      tableDynamicClassname="taxroll-custom-table" tableDynamicHeight="130" />
    </v-col>
    </v-row>
  </v-col>

    <v-col cols="12" class="pt-0 pb-0">
      <div class="d-flex align-center">
        <v-btn class="input-text-size" text color="blue darken-1"
        @click="openIndividualDeed">Print Individual Deed</v-btn>
        <v-btn class="input-text-size" text color="blue darken-1"
        @click="openCountyDeed('County')" :disabled="!editedItem.countyOwned">Print County Deed</v-btn>
        <v-btn class="input-text-size" text color="blue darken-1"
        @click="openCountyDeed('City')" :disabled="!editedItem.cityOwned">Print City Deed</v-btn>
        <v-btn class="input-text-size" text color="blue darken-1"
        @click="createPayment" :disabled="createPaymentDisabled">Create Payment</v-btn>
        <p class="mb-0 ml-2">Payment#: {{ editedItem.paymentNumber || '' }}</p>
      </div>
    </v-col>
  </v-row>
  <CommonPopUp v-model="showOrHidePrintDeedErrorMsg" v-if="showOrHidePrintDeedErrorMsg"
    :enableFlashTypeMsg="true" flashType="warning">
      <template v-slot:customsLabelOrInfo>
        <p class="mt-3">This will adjust the taxes down to match the amount collected, and cannot be easily undone.<br/>
Are you sure you want to continue?</p>
      </template>
      <template v-slot:[`customsButtonsForPopUp`]="{}">
        <v-btn class="input-text-size" text color="blue darken-1"
        @click="openConfirmAdjustmentsPopUp('continue')">Continue</v-btn>
        <v-btn class="input-text-size" text color="blue darken-1"
        @click="openConfirmAdjustmentsPopUp('cancel')">Cancel</v-btn>
      </template>
  </CommonPopUp>
  <v-dialog v-model="individualDeedDialogFlag" max-width="700">
  <v-card>
    <v-card-title class="input-text-size">
      Enter Information for Individual Resale Deed
    </v-card-title>
    <v-card-text class="input-text-size">
      <v-container>
        <v-text-field class="input-text-size mt-n4"
          label="Actual Bidder" v-model="individualResaleDeedDialogInfo.actualBidder" />
          <!-- <div v-for="(resaleItem, index) in individualResaleDeedDialogInfo.resaleItemsForIndividualDeed"
          :key="index">
          <v-row no-gutters align="center">
            <v-col cols="6">
              <v-text-field
                class="input-text-size mt-n4"
                label="City, Town or Subdivision"
                v-model="resaleItem.cityOrTown"
              />
            </v-col>
            <v-col cols="6" class="pl-4 input-text-size">
              {{ shortenLegalDesc(resaleItem.mainLegalDesc) }}
            </v-col>
          </v-row>
        </div> -->
        <ClarionDateControl class="input-text-size mt-n3" :isToggle="false"
          v-model="individualResaleDeedDialogInfo.deedDate" label="Deed Date" />
      </v-container>
    </v-card-text>
    <v-card-actions class="input-text-size">
      <v-btn color="primary" small @click="printIndividualDeed">
        Ok
      </v-btn>
      <v-btn small @click="closeIndividualDeed">Close</v-btn>
    </v-card-actions>
  </v-card>
  </v-dialog>
  <v-dialog v-model="countyDeedDialogFlag" max-width="400">
  <v-card>
    <v-card-title class="input-text-size">
      Enter Information for {{isItCountyOrCity}} Resale Deed
    </v-card-title>
    <v-card-text class="input-text-size">
      <v-container>
        <v-text-field class="input-text-size mt-n4"
          :label="isItChairpersonOrCity" v-model="countyResaleDeedDialogInfo.chairPerson" />
        <ClarionDateControl class="input-text-size mt-n3" :isToggle="false"
          v-model="countyResaleDeedDialogInfo.deedDate" label="Deed Date" />
      </v-container>
    </v-card-text>
    <v-card-actions class="input-text-size">
      <v-btn color="primary" small @click="printCountyDeed">
        Ok
      </v-btn>
      <v-btn small @click="closeCountyDeed">Close</v-btn>
    </v-card-actions>
  </v-card>
  </v-dialog>
</div>
</template>

<script>
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import { amountFormat, amountToNumber } from '../../../../../util/shared/vue-global';
import CRUDList from '../../../../common/base/crud-2.0/CRUDList.vue';
import CommonPopUp from '../../../common-utils/CommonPopUp.vue';
import { generateQueryString } from '../../../../common/base/report/report-util';
import { clients } from '../../../../../util/clients';
import ClarionDateControl from '../../../../common/ClarionDateControl.vue';
import { resaleExcessUnit } from '../../../common-utils/tax-common.util';

const { backendRest } = clients.direct;
export default {
  name: 'DayOfSaleDialog',
  components: {
    CRUDList,
    CommonPopUp,
    ClarionDateControl,
  },
  data() {
    return {
      baseCrudKeyPriority: 'PriorityBaseCrudKey',
      showOrHidePrintDeedErrorMsg: false,
      disableCreateAdjustments: true,
      createPaymentDisabled: true,
      individualDeedDialogFlag: false,
      countyDeedDialogFlag: false,
      isItCountyOrCity: 'County',
      isItChairpersonOrCity: 'Chairperson',
      individualResaleDeedDialogInfo: {
        actualBidder: '',
        deedDate: '',
        // resaleItemsForIndividualDeed: [],
      },
      countyResaleDeedDialogInfo: {
        chairPerson: '',
        deedDate: '',
      },
    };
  },
  props: {
    baseCrudKey: {
      type: String,
      default: 'DayOfSaleDialog',
    },
    baseCrudKeyForBidderRegistration: {
      type: String,
      default: 'BidderRegistrationBaseCrudKey',
    },
    creatingAdjustments: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
      'items',
      'criteria',
      'index',
      'isVisible',
    ]),
    ...mapState({
      resaleSettingItem: (state) => state.SystemConfig.resaleSettingItem || {},
      isVisibleDayOfSaleDialog: (state) => state.base.crud.isVisible.DayOfSale,
      taxFeeMasterData: (state) => state.shared.taxFeeMaster.taxFeeMasterData || [],
    }),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKeyAdditional);
      },
      set(value) {
        this.setCriteria([this.baseCrudKeyAdditional, value]);
      },
    },
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    headers() {
      return [
        { text: '', value: 'priority', sortable: false },
        {
          text: 'Amount Due', value: 'amountDue', sortable: false, formatter: 'amount', align: 'right',
        },
        {
          text: 'Available', value: 'available', sortable: false, formatter: 'amount', align: 'right',
        },
        { text: '% Paid', value: 'paidPercentage', sortable: false },
      ];
    },
    getBidderRegistrationItems() {
      return this.items(this.baseCrudKeyForBidderRegistration) || [];
    },
    defaultSortBy() {
      return [
        { column: 'adjustmentType', direction: 'asc' },
      ];
    },
  },
  methods: {
    amountFormat,
    ...mapMutations('base/crud', ['setIsVisible', 'setItem', 'setItems', 'setHighlightedId']),
    ...mapActions(['custumColrFlashMsg']),
    ...mapActions('tax/juneResale', [
      'loadJuneResale',
      'loadJuneResaleNameAndAddresses',
      'deleteJuneResaleRowItem',
    ]),
    ...mapActions(['reAuth']),
    getCalculatedPriorityAmount(pendingAmount, totalAmount) {
      let pendingAmt = pendingAmount;
      const formattedAmount = amountToNumber(totalAmount);
      let availableAmount = 0;
      let paidPercentage = 0;
      if (pendingAmt > 0) {
        pendingAmt = pendingAmount - formattedAmount;
        availableAmount = pendingAmount;
        const remainingAmount = pendingAmount;
        paidPercentage = (remainingAmount / formattedAmount) * 100;
        if (pendingAmt >= 0) {
          availableAmount = formattedAmount;
          paidPercentage = 100;
        }
        if (paidPercentage < 100 && paidPercentage > 0) {
          paidPercentage = paidPercentage.toFixed(2);
        }
      }
      return {
        availableAmount,
        paidPercentage,
        pendingAmt,
      };
    },
    onCountyOwnedChange() {
      if (!this.editedItem.isAdjustedCreated) {
        if (this.editedItem.countyOwned || this.editedItem.cityOwned) {
          this.disableCreateAdjustments = false;
        } else {
          this.disableCreateAdjustments = true;
        }
      } else {
        this.disableCreateAdjustments = true;
      }
    },
    calculateDynamicPriority() {
      const {
        // mainTotalFeesDue is no longer used here, the fees are calculated from the tax details
        mainTotalPenalty, winningBid,
        mainTotalDue, taxDetails, mainTwoThirdsAssessed,
      } = this.editedItem;

      const winningBidToNumber = amountToNumber(winningBid);
      const mainTotalDueToNumber = amountToNumber(mainTotalDue);
      const mainTwoThirdsAssessedToNumber = amountToNumber(mainTwoThirdsAssessed);

      let excessResale = winningBidToNumber - mainTotalDueToNumber;

      if (!this.editedItem.isPaymentCreated) {
        if ((winningBidToNumber > mainTotalDueToNumber)
         || (winningBidToNumber === mainTotalDueToNumber)) {
          this.createPaymentDisabled = false;
        } else {
          this.createPaymentDisabled = true;
        }
      } else {
        this.createPaymentDisabled = true;
      }

      if (!this.editedItem.isAdjustedCreated) {
        if (winningBidToNumber >= mainTwoThirdsAssessedToNumber && winningBidToNumber < mainTotalDueToNumber) {
          this.disableCreateAdjustments = false;
        } else {
          this.disableCreateAdjustments = true;
        }
      } else {
        this.disableCreateAdjustments = true;
      }
      if (excessResale < 0) {
        excessResale = 0;
      }
      this.setItem([
        this.baseCrudKey,
        { ...this.editedItem, excessResale: amountFormat(excessResale) },
      ]);

      const {
        resaleFees, resaleTaxes, resalePenalty, resaleSA,
      } = this.resaleSettingItem;
      const priorityMap = [
        { key: 'Taxes', value: amountToNumber(resaleTaxes || 3) },
        { key: 'Penalty', value: amountToNumber(resalePenalty || 2) },
        { key: 'Fees', value: amountToNumber(resaleFees || 1) },
        { key: 'Special Assessments', value: amountToNumber(resaleSA || 4) },
        { key: 'Excess Resale', value: 5 },
      ];
      priorityMap.sort((a, b) => (a.value - b.value));
      const keysInOrder = priorityMap.map((item) => item.key);
      const calculatedPriorityListy = [];
      let pendingAmount = winningBidToNumber;

      // get the total tax amount of the special assessments
      const filterSAandGetTotalTaxAmount = (taxDetails || []).reduce((acc, item) => {
        if (item.taxType === 'S') {
          return acc + amountToNumber(item.totalTaxDue || 0);
        }
        return acc;
      }, 0);

      // calculate the fees from the tax details instead of the stored mainTotalFeesDue
      const totalFeesAmount = (taxDetails || []).reduce(
        (acc, item) => acc + amountToNumber(item.totalFeesDue || 0), 0,
      );

      for (const key of keysInOrder) {
        if (key === 'Taxes') {
          const totalTaxAmount = (taxDetails || []).reduce((acc, item) => {
            if (item.taxType !== 'S') {
              return acc + amountToNumber(item.totalTaxDue || 0);
            }
            return acc;
          }, 0);
          const {
            availableAmount, paidPercentage, pendingAmt,
          } = this.getCalculatedPriorityAmount(pendingAmount, totalTaxAmount);
          pendingAmount = pendingAmt;
          calculatedPriorityListy.push({
            priority: key,
            amountDue: totalTaxAmount,
            available: availableAmount,
            paidPercentage,
          });
        }
        if (key === 'Penalty') {
          const {
            availableAmount, paidPercentage, pendingAmt,
          } = this.getCalculatedPriorityAmount(pendingAmount, amountToNumber(mainTotalPenalty));
          pendingAmount = pendingAmt;
          calculatedPriorityListy.push({
            priority: key,
            amountDue: mainTotalPenalty,
            available: availableAmount,
            paidPercentage,
          });
        }
        if (key === 'Fees') {
          // fees are now summed from the tax details
          // } = this.getCalculatedPriorityAmount(pendingAmount, amountToNumber(mainTotalFeesDue));
          const {
            availableAmount, paidPercentage, pendingAmt,
          } = this.getCalculatedPriorityAmount(pendingAmount, totalFeesAmount);
          pendingAmount = pendingAmt;
          calculatedPriorityListy.push({
            priority: key,
            // amountDue: mainTotalFeesDue,
            amountDue: totalFeesAmount,
            available: availableAmount,
            paidPercentage,
          });
        }
        if (key === 'Special Assessments') {
          const {
            availableAmount, paidPercentage, pendingAmt,
          } = this.getCalculatedPriorityAmount(pendingAmount, filterSAandGetTotalTaxAmount);
          pendingAmount = pendingAmt;
          calculatedPriorityListy.push({
            priority: key,
            amountDue: filterSAandGetTotalTaxAmount,
            available: availableAmount,
            paidPercentage,
          });
        }
        if (key === 'Excess Resale') {
          let availableAmount = pendingAmount;
          if (pendingAmount < 0) {
            availableAmount = 0;
          }
          calculatedPriorityListy.push({
            priority: key,
            amountDue: 0,
            available: availableAmount,
            paidPercentage: 0,
          });
        }
        this.setItems([this.baseCrudKeyPriority, calculatedPriorityListy]);
      }
    },
    roundAmount(fieldName) {
      this.editedItem[fieldName] = amountFormat(this.editedItem[fieldName]);
    },
    amountToNum(fieldName) {
      this.editedItem[fieldName] = amountToNumber(this.editedItem[fieldName]);
    },
    openConfirmAdjustmentsPopUp(value) {
      if (value === 'continue') {
        this.$emit('createAdjustments', this.editedItem);
      }
      this.showOrHidePrintDeedErrorMsg = false;
    },
    createAdjustments() {
      this.showOrHidePrintDeedErrorMsg = true;
    },
    closeIndividualDeed() {
      this.individualDeedDialogFlag = false;
      this.individualResaleDeedDialogInfo.deedDate = '';
      this.individualResaleDeedDialogInfo.actualBidder = '';
      // this.individualResaleDeedDialogInfo.resaleItemsForIndividualDeed = [];
    },
    async openIndividualDeed() {
      // const { saleYear, regNumber } = this.editedItem;
      // if (saleYear && regNumber) {
      //   const criteria = { saleYear, regNumber };
      //   this.individualResaleDeedDialogInfo.resaleItemsForIndividualDeed = await this.loadJuneResale({ criteria }) || [this.editedItem];
      // } else {
      //   this.individualResaleDeedDialogInfo.resaleItemsForIndividualDeed = [this.editedItem];
      // }
      this.individualDeedDialogFlag = true;
      this.$emit('upsertItem', this.editedItem, true);
    },
    openCountyDeed(whichOne) {
      if (whichOne === 'County') this.isItChairpersonOrCity = 'Chairperson';
      else this.isItChairpersonOrCity = 'City';
      this.isItCountyOrCity = whichOne;
      this.countyDeedDialogFlag = true;
      this.$emit('upsertItem', this.editedItem, true);
    },
    closeCountyDeed() {
      this.isItCountyOrCity = 'County';
      this.countyDeedDialogFlag = false;
      this.countyResaleDeedDialogInfo.chairPerson = '';
      this.countyResaleDeedDialogInfo.deedDate = '';
    },
    async printIndividualDeed() {
      const { jwt } = await this.reAuth();
      const params = [
        `token=${jwt}`,
        `actualBidder=${this.individualResaleDeedDialogInfo.actualBidder || ''}`,
        `deedDate=${this.individualResaleDeedDialogInfo.deedDate || ''}`,
        `regNumber=${this.editedItem.regNumber || ''}`,
        `saleYear=${this.editedItem.saleYear || ''}`,
        `id=${this.editedItem._id || ''}`,
      ];
      if (this.devSetting && this.devSetting.isTestEnvironment) {
        params.push('isTestCafe=1');
      }
      const queryString = generateQueryString(params);
      const url = `${backendRest.defaults.baseURL}/juneResale/individual-deed${queryString}`;

      this.closeIndividualDeed();
      window.open(url, '_blank');
    },
    async printCountyDeed() {
      const { jwt } = await this.reAuth();
      const params = [
        `token=${jwt}`,
        `chairPerson=${this.countyResaleDeedDialogInfo.chairPerson || ''}`,
        `deedDate=${this.countyResaleDeedDialogInfo.deedDate || ''}`,
        `id=${this.editedItem._id || ''}`,
      ];
      if (this.devSetting && this.devSetting.isTestEnvironment) {
        params.push('isTestCafe=1');
      }
      const queryString = generateQueryString(params);
      let url = `${backendRest.defaults.baseURL}/juneResale/county-deed${queryString}`;
      if (this.isItCountyOrCity === 'City') url = `${backendRest.defaults.baseURL}/juneResale/city-deed${queryString}`;

      this.closeCountyDeed();
      window.open(url, '_blank');
    },
    createPayment() {
      // before creating payments these needs to be checked first
      const feeResale = resaleExcessUnit;
      const filteredTaxMasterList = (this.taxFeeMasterData || [])
        .filter((ft) => (ft.toUnit || '').toLowerCase() === feeResale);
      if ((filteredTaxMasterList || []).length) this.$emit('createPayment', this.editedItem);
      else window.alert('No Excess Resale Fee is found. Please create a fee record with a To Unit of "EXCESS" and then re-attempt to create a payment from this resale record');
    },
    updateRegNumber() {
      const bidderRegistrationItems = this.getBidderRegistrationItems || [];
      if (!this.editedItem.regNumber) return;
      const bidderRegistrationItem = bidderRegistrationItems
        .find((item) => amountToNumber(item.regNumber)
         === amountToNumber(this.editedItem.regNumber));
      let bidderName = '';
      if (bidderRegistrationItem) {
        bidderName = bidderRegistrationItem.bidderName || '';
      } else {
        this.custumColrFlashMsg({
          msg: 'Registration number not found. Please check the Bidder registration.',
        });
      }
      this.setItem([
        this.baseCrudKey,
        { ...this.editedItem, bidderName },
      ]);
    },
    shortenLegalDesc(legal) {
      if ((legal || '').length > 40) return `${(legal || '').slice(0, 40)}...`;
      return legal || '';
    },
  },
  watch: {
    isVisibleDayOfSaleDialog(newVal) {
      if (newVal) {
        this.calculateDynamicPriority();
      }
    },
  },
};
</script>
